<template>
  <div class="register absolute bindcoupon">
    <div class="showbox" v-if="showbox">
      <div class="showTile">
        <img src="@assets/images/logo.png" alt="">

        小将文化 申请获得
      </div>
      <strong>
        以下权限
      </strong>
      <p>
        获得你的公开信息（昵称、头像、地区及性别）
      </p>

      <button @click="btnfalse()">同意</button>
    </div>
    <div class="shading" v-if="false">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logoWhrite.png" v-else />
      </div>
    </div>
    <div class="img">
      <!-- <img :src="logoUrl" alt="" /> -->
      <!-- <img src="@assets/images/loginbanner.jpeg" alt="" /> -->
    </div>
    <!-- @click="navTap(index)" -->
    <div class="whiteBg" v-if="formItem === 1">
      <div class="title acea-row row-center-wrapper">
        <div class="item" :class="current === index ? 'on' : ''" v-for="(item, index) in navList" :key="index">
          <!-- {{ item }} -->
        </div>
      </div>
      <div class="list" :hidden="current !== 1">
        <h2 class="htitle">绑定点券</h2>
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true" v-if="false">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <label for="">券号</label>
              <input type="text" placeholder="请输入券号" v-model="account" required />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true" v-if="false">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <label for="">券密</label>
              <input type="password" placeholder="请输入券密" v-model="password" required />
            </div>
          </div>
        </form>
        <div class="forgetPwd" @click="$router.push({ name: 'RetrievePassword' })" v-if="false">
          <span class="iconfont icon-wenti"></span>忘记券密
        </div>
      </div>
      <div class="list" :hidden="current !== 0">
        <div class="item">
          <div class="acea-row row-between-wrapper">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
            <button class="code" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="code">
              {{ text }}
            </button>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile" :hidden="current == 1">确认</div>
      <div class="logon" @click="submit" :hidden="current !== 1">确认</div>
      <div class="tip" v-if="false">
        没有券号?
        <span @click="formItem = 2" class="font-color-red">立即注册</span>
      </div>
    </div>
    <div class="whiteBg" v-else>
      <div class="title">注册券号</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input type="text" placeholder="填写验证码" class="codeIput" v-model="captcha" />
            <button class="code" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="code">
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input type="password" placeholder="填写您的登录券密" v-model="password" />
          </div>
        </div>
      </div>
      <div class="logon" @click="register">注册</div>
      <div class="tip">
        已有券号?
        <span @click="formItem = 1" class="font-color-red">立即登录</span>
      </div>
    </div>
    <div class="bottom" v-if="false"></div>

    <!-- 登录提示弹窗 -->
    <Overlay :show="isShow" duration="0">
      <div class="dialog-warp">
        <div class="size1">此微信账号已绑定<span>{{ prompt }}</span></div>
        <div class="size2">请更换此手机号登录</div>
        <div class="size3">*如需更换绑定手机，请致电客服热线 400-003-5989</div>
        <div class="button">
          <div class="buttonson" @click="isShow = false">确 定</div>
        </div>
      </div>
    </Overlay>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  islogin,
  login,
  loginMobile,
  mobilCheck,
  registerVerify,
  register,
  bind
} from "@api/user";
import { getLogo, wechatAuth } from "@api/public";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import dayjs from "dayjs";
import cookie from "@utils/store/cookie";
import { parseQuery } from "@utils";
const BACK_URL = "login_back_url";
import { toAuth } from "@libs/wechat"
import { isWeixin } from "@utils";
import { Overlay } from "vant";

export default {
  name: "BindingPhone",
  mixins: [sendVerifyCode],
  data: function () {
    return {
      navList: ["券号登录", "快速登录"],
      current: 1,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      isShow: false,
      prompt: '',
      showbox: false
    };
  },
  components: {
    Overlay
  },
  mounted: function () {

    this.getLogoImage();
    islogin();
    console.log(islogin());

    this.btnfalse();

    // 设置授权
    ///cookie.set(BACK_URL,"/", "Session");

    // islogin().then(data => {
    //   console.log(data);
    //   cookie.set("islogin",data.data.islogin, "Session")
    //   if (data.data.islogin == 1) {
    //     this.$router.push("/home");
    //   }
    // });


  },
  methods: {
    btnfalse() {
      // toAuth();
      console.log(isWeixin());
      return false;
      this.showbox = !this.showbox
    },

    async getLogoImage() {
      let that = this;
      getLogo(3).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      mobilCheck({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread"),
        is_weixin: isWeixin(),
        uid: sessionStorage.getItem('UID'),
        opid: sessionStorage.getItem('OPID')
      }).then(res => {
        this.prompt = res.data.prompt
        if (res.data.prompt == '') {
          loginMobile({
            phone: that.account,
            captcha: that.captcha,
            spread: cookie.get("spread"),
            is_weixin: isWeixin(),
            uid: sessionStorage.getItem('UID'),
            opid: sessionStorage.getItem('OPID')
          })
            .then(res => {
              let data = res.data;
              let expires_time = data.expires_time.substring(0, 19);
              expires_time = expires_time.replace(/-/g, "/");
              expires_time = new Date(expires_time).getTime() - 28800000;
              const datas = {
                token: data.token,
                expires_time: expires_time
              };
              //判断有没有绑卡
              let card = data.is_bind;
              if (card) {
                that.$store.commit("LOGIN", datas);
                cookie.set('isbind', true);
                const backUrl = cookie.get(BACK_URL) || "/";
                that.$router.replace({ path: backUrl });
                cookie.remove(BACK_URL);
              } else {
                cookie.set('isbind', false);
                cookie.set('temporary_token', datas.token || '');
                cookie.set('temporary_expires', datas.expires_time || '');
                this.$router.push({ path: "/user/bindcoupon", query: { id: 1 } });
              }
            })
            .catch(res => {
              that.$dialog.error(res.msg);
            });
        } else {
          this.isShow = true
        }
      })
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("券密")),
              attrs.range([6, 16], attrs.range.message("券密")),
              alpha_num(alpha_num.message("券密"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      await registerVerify({ phone: that.account, type: that.type })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    navTap: function (index) {
      this.current = index;
      console.log(this.current);
    },
    async submit() {
      const { account, password } = this;
      try {
        this.$validator({
          account: [
            required(required.message("券号")),
            attrs.range([5, 16], attrs.range.message("券号")),
            alpha_num(alpha_num.message("券号"))
          ],
          password: [
            required(required.message("券密")),
            attrs.range([6, 16], attrs.range.message("券密")),
            alpha_num(alpha_num.message("券密"))
          ]
        }).validate({ account, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      bind({ account, password })
        .then(res => {

          if (res.status == 200) {

            this.$dialog.success(res.msg);

            if (this.$route.query.id == '1') {
              let datas = {
                expires_time: cookie.get('temporary_expires'),
                token: cookie.get('temporary_token')
              };
              this.$store.commit("LOGIN", datas);
              cookie.set('isbind', true);
              cookie.remove('temporary_expires');
              cookie.remove('temporary_token');
            }

            const backUrl = cookie.get(BACK_URL) || "/user";
            cookie.remove(BACK_URL);
            this.$router.replace({ path: backUrl });

          } else {
            this.$dialog.error(res.msg);

          }
          /*
          this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
          const backUrl = cookie.get(BACK_URL) || "/user";
          cookie.remove(BACK_URL);

          this.$router.replace({ path: backUrl });*/
          // this.$router.push("");
        })
        .catch(e => {
          // console.log(222);
          this.$dialog.error(e.msg);
        });
    }
  }
};
</script>
<style>
.home {
  display: none !important;
}

.showbox {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 666;
  background: #fff;
  color: rgba(0, 0, 0, 0.9);
}

.showbox button {
  width: 184px;
  background: #07c160;
  color: #fff;
  padding: 10px 20px;
  display: block;
  margin: 100px auto;
  border-radius: 4px;
}

.showbox .showTile {
  overflow: hidden;
  line-height: 30px;
  margin: 40px 0 0 40px;
}

.showbox .showTile img {
  height: 30px;
  margin-right: 15px;
  background: #f5f5f5;
  display: block;
  float: left;
}

.showbox strong {
  font-size: 24px;
  font-weight: normal;
  margin: 20px 0 0 40px;
  display: block;
}

.showbox p {
  font-size: 16px;
  margin: 40px 0 0 40px;
}

/* login */
.img {
  width: 100%;
  overflow: hidden;
}

.img img {
  width: 100%;
  display: block;
}

.bindcoupon .whiteBg {
  width: 100%;
  border-radius: 0;
  margin: 0;
  height: 100%;
}

.htitle {
  font-size: 0.32rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #ededed;
  text-align: center;
}

.bindcoupon .whiteBg .logon {
  background: #f74115;
  border-radius: 0.1rem;
}
</style>
